import { atom } from "recoil";

export const isLoggedOutState = atom({
  key: "isLoggedOutState",
  default: false,
});

export const isSignUpInProgressState = atom({
  key: "isSignUpInProgressState",
  default: false,
});
